import { useMemo } from 'react';
import type { SceneMap } from './interfaces';
import { RouteKey } from './interfaces';
import { FolderTabDetails } from './Tab.Details';
import { FolderTabFiles } from './Tab.Files';

export const useFolderTabsMap = () => {

  const map: SceneMap = useMemo(() => ({
    [RouteKey.Files]: {
      component: FolderTabFiles,
      path: `files`,
      title: 'Files',
    },
    [RouteKey.Details]: {
      component: FolderTabDetails,
      path: `details`,
      title: 'Details',
    },
  }), []);

  return map;
};